import { useCallback, useMemo, useState } from "react";

import { findCompetitorItemById, getCompetitorItemId } from "../utils";

export const useCompetitorsPreview = ({ galleryDisplayData }) => {
  const [previewItemId, setPreviewItemId] = useState(null);
  const [previewMediaOverride, setPreviewMediaOverride] = useState(null);

  const previewItem = useMemo(() => {
    const item = findCompetitorItemById({
      items: galleryDisplayData,
      itemId: previewItemId,
    });

    if (!item) return null;

    if (!previewMediaOverride?.url) return item;

    return {
      ...item,
      url: previewMediaOverride.url,
      ...(previewMediaOverride.type ? { type: previewMediaOverride.type } : {}),
    };
  }, [galleryDisplayData, previewItemId, previewMediaOverride]);

  const isPreviewOpen = previewItemId !== null && previewItem !== null;

  const onOpenPreview = useCallback(
    (previewParams) => {
      const index =
        typeof previewParams === "number"
          ? previewParams
          : previewParams?.index;
      const item = galleryDisplayData[index];
      if (!item) return;

      const url =
        typeof previewParams === "object" ? previewParams?.url : undefined;
      const type =
        typeof previewParams === "object" ? previewParams?.type : undefined;

      setPreviewItemId(getCompetitorItemId(item));
      setPreviewMediaOverride(url ? { url, ...(type ? { type } : {}) } : null);
    },
    [galleryDisplayData]
  );

  const onClosePreview = useCallback(() => {
    setPreviewItemId(null);
    setPreviewMediaOverride(null);
  }, []);

  const resetPreview = useCallback(() => {
    setPreviewItemId(null);
    setPreviewMediaOverride(null);
  }, []);

  return {
    previewItem,
    isPreviewOpen,
    onOpenPreview,
    onClosePreview,
    resetPreview,
  };
};

export default useCompetitorsPreview;
